<div class="tabs-container">
  <div class="tabs-bar" role="tablist">
    @for (tab of tabs; track tab) {
      <div
        class="tab"
        [attr.data-cy]="'tab-' + tab.label.toLowerCase().replace(' ', '-')"
        [class.active]="isActive(tab)"
        [class.highlight]="tab.route === 'upgrade' && !tab.loading"
        [class.loading]="tab.loading"
        role="tab"
        [attr.aria-selected]="isActive(tab)"
        tabindex="0"
        (click)="navigateToTab(tab)"
        (keydown)="handleKeyDown($event)"
      >
        <div class="tab-button-content">
          @if (tab.loading) {
            <i class="fa-solid fa-spinner fa-spin tab-icon"></i>
          }
          @if (tab.icon && !tab.loading) {
            <i [class]="tab.icon" class="tab-icon"></i>
          }
          <span class="tab-label">{{ tab.label }}</span>
        </div>
      </div>
    }
  </div>
</div>
